<div class="wrapper">
  <a mat-button class="page-back" routerLink="/schools" aria-label="Back to schools">
    <mat-icon fontIcon="arrow_back" aria-hidden="true"></mat-icon>
    <span>Back to schools</span>
  </a>

  <div class="title-bar title-bar--responsive">
    <div class="title-bar__heading">
      <h1 id="create-school-heading">Create a school</h1>
    </div>
  </div>

  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <h2>School details</h2>
      </mat-card-title>
      <mat-card-subtitle>New schools start as Coming Soon with starter costs, packaging, and the methodology’s required questions.</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="field-group field-group--code">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>School code</mat-label>
            <input matInput formControlName="code" autocomplete="off" autocapitalize="none" spellcheck="false" aria-describedby="school-code-hint" (input)="onCodeInput($event)" />
            @if (codeError(); as message) {
              <mat-error>{{ message }}</mat-error>
            }
          </mat-form-field>
          <p id="school-code-hint" class="field-hint">Lowercase letters, numbers, and hyphens. This becomes the public URL.</p>
        </div>

        <mat-form-field appearance="outline" class="field-group--name">
          <mat-label>School name</mat-label>
          <input matInput formControlName="name" autocomplete="organization" />
          @if (form.controls.name.touched && form.controls.name.invalid) {
            <mat-error>Enter a school name.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="field-group--method">
          <mat-label>Methodology</mat-label>
          <mat-select formControlName="institutionalMethod">
            <mat-option [value]="false">Federal Methodology</mat-option>
            <mat-option [value]="true">Institutional Methodology</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="field-group--org">
          <mat-label>Organization ID</mat-label>
          <input matInput formControlName="orgId" autocomplete="off" />
          @if (form.controls.orgId.touched && form.controls.orgId.invalid) {
            <mat-error>Enter an organization ID.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="field-group--year">
          <mat-label>Aid year</mat-label>
          <mat-select formControlName="aidYear">
            @for (year of aidYears; track year.code) {
              <mat-option [value]="year.code">{{ year.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (errorMessage) {
          <p class="create-school__error" role="alert">{{ errorMessage }}</p>
        }

        <div class="page-actions">
          <button mat-raised-button color="primary" type="submit" [disabled]="saving">
            {{ saving ? 'Creating…' : 'Create school' }}
          </button>
          <a mat-button routerLink="/schools">Cancel</a>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <p class="page-secondary">
    <a routerLink="/defaults/content">Edit default content</a>
  </p>
</div>
